import React, { useEffect, useRef, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import axios from "axios";
import { API_BASE_URL, demostate } from "../../../global";
import pako from "pako";
import jsPDF from "jspdf";
import Logo from "../../Assets/images/attestaai-logo.png";
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import moment from "moment";


const VerticalTimelinePreview = ({
    isverticaltimeopen,
    handleCloseSverticaltimelineModal,
    caseName
}) => {
    const [verticalloading, setVerticalloading] = useState(true);
    const [isDownloading, setIsDownloading] = useState(false);
    const [timelineData, setTimelineData] = useState([]);
    const ref = useRef(null);

    const bgColors = ["#ffe6f0", "#e6f0ff", "#f0e6ff", "#fff0e6", "#cfcee5ff"];

    useEffect(() => {
        if (isverticaltimeopen) {
            setTimeout(() => {
                setVerticalloading(false);
            }, 1000);
        }
    }, [isverticaltimeopen]);
    useEffect(() => {
        fetchTimelineData();
    }, []);
    const fetchTimelineData = async () => {
        try {
            setVerticalloading(true);
            const caseID = localStorage.getItem("caseID");
            const filter_timeline_report = localStorage.getItem("filter_timeline_report");
            const payload = {
                mode: "report_data",
                case_id: caseID,
            };

            if (filter_timeline_report) {
                try {
                    const parsed = JSON.parse(filter_timeline_report); // e.g. ["1,2,3,4,5"]
                    let pages;

                    if (Array.isArray(parsed)) {

                        if (typeof parsed[0] === "string") {
                            pages = parsed[0].split(",").map(Number);
                        } else {
                            pages = parsed.map(Number);
                        }
                    } else if (typeof parsed === "string" || typeof parsed === "number") {

                        pages = [Number(parsed)];
                    } else {
                        pages = [];
                    }
                    payload.search_keyword_page_no = pages;
                } catch {
                    payload.search_keyword_page_no = filter_timeline_report.split(",").map(Number);
                }
            }
            const response = await axios.post(`${API_BASE_URL}timeline`, payload);

            if (response.data && response.data.status === 1) {
                try {

                    const compressed = response.data?.timeline_report;
                    const decoded = atob(compressed);
                    const uint8Array = new Uint8Array([...decoded].map((c) => c.charCodeAt(0)));
                    const decompressed = pako.inflate(uint8Array, { to: "string" });
                    const result = JSON.parse(decompressed);
                    setTimelineData(result);
                    console.log(result)
                } catch (error) {
                    console.error("Error decoding timeline:", error);
                    setTimelineData([]);
                }

            } else {
                console.error("Invalid API response format or missing payload.");
                setTimelineData([]);
            }
        } catch (error) {
            console.error("Error fetching report list:", error);
        } finally {
            setTimeout(() => {
                setVerticalloading(false);
            }, 2000);
        }
    }
    const renderTimelineCards1 = () => {
        let lastDate = "";
        return (
            <div
                style={{
                    position: "relative",
                    marginLeft: "80px",
                    padding: "20px 0",
                }}
            >
                {/* Vertical line */}


                {timelineData.map((entry, index) => {
                    const color = bgColors[index % bgColors.length];
                    const showDate = entry.caseFactDate !== lastDate;
                    if (showDate) lastDate = entry.caseFactDate;

                    return (
                        <div key={index} style={{ position: "relative", marginBottom: "60px" }}>
                            {/* Date label on left */}
                            {showDate && (
                                <>
                                    <div
                                        style={{
                                            position: "absolute",
                                            left: "-80px",
                                            top: "10px",
                                            fontWeight: 600,
                                            color: "#000",
                                            fontSize: "14px",
                                        }}
                                    >
                                        {entry.caseFactDate}
                                    </div>
                                    {/* Circle marker */}
                                    <div
                                        style={{
                                            position: "absolute",
                                            left: "56px",
                                            top: "20px",
                                            width: "14px",
                                            height: "14px",
                                            backgroundColor: "#000",
                                            borderRadius: "50%",
                                        }}
                                    ></div>
                                </>
                            )}




                            {/* Timeline card */}
                            <div
                                style={{
                                    backgroundColor: color,
                                    padding: "20px",
                                    borderRadius: "8px",
                                    width: "75%",
                                    boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                                    marginLeft: "100px",
                                }}
                            >
                                <div style={{ fontWeight: "bold", fontSize: "15px" }}>
                                    {entry.caseFactLabel}
                                </div>
                                {/* <div
                                    style={{
                                        fontSize: "14px",
                                        color: "#333",
                                        marginTop: "8px",
                                        lineHeight: "1.5",
                                    }}
                                >
                                    {entry.caseFactsSummary}
                                </div> */}
                                <div style={{ fontSize: "14px", color: "#333", marginTop: "8px", lineHeight: "1.5" }}>
                                    {/* <strong>Date:</strong> {moment(entry?.caseFactDate).format("MMM DD, YYYY")}<br /> */}
                                    <strong>Provider:</strong> {entry?.caseFactProvider || 'N/A'}<br />
                                    <strong>Organization:</strong> {entry?.caseFactOrg || 'N/A'}<br />
                                    <strong>Page Range:</strong> {entry?.caseFactPageRange || 'N/A'}<br />
                                    <div style={{ display: "flex", alignItems: "flex-start" }}>
                                        <strong style={{ minWidth: "90px" }}>Summary:</strong>
                                        <span style={{ fontWeight: "normal", flex: 1, textAlign: "justify" }}>
                                            {entry?.caseFactsSummary || 'N/A'}
                                        </span>
                                    </div>
                                </div>

                            </div>
                        </div>
                    );
                })}
                <div
                    style={{
                        position: "absolute",
                        left: "61px",
                        top: "0",
                        bottom: "0",
                        width: "4px",
                        backgroundColor: "#000",
                    }}
                ></div>
            </div>
        );
    };

    const renderTimelineCards = () => {
       
        if (!timelineData || timelineData.length === 0) {
            return (
                <div
                    style={{
                        padding: "40px",
                        textAlign: "center",
                        color: "#666",
                        fontSize: "14px",
                        fontWeight: 500,
                    }}
                >
                    No data available
                </div>
            );
        }
        let lastDate = "";

        return (
            <div style={{ position: "relative", marginLeft: "80px", padding: "20px 0" }}>

                {/* Arrow before first circle */}
                <div
                    style={{
                        position: "absolute",
                        left: "55px",
                        top: "-10px",
                        fontSize: "22px",
                        fontWeight: 800,
                    }}
                >
                    <i class="fa-solid fa-arrow-down"></i>
                </div>

                {timelineData.map((entry, index) => {
                    const color = bgColors[index % bgColors.length];
                    const showDate = entry.caseFactDate !== lastDate;
                    if (showDate) lastDate = entry.caseFactDate;

                    const isLast = index === timelineData.length - 1;

                    return (
                        <div key={index} style={{ position: "relative", marginBottom: "60px" }}>

                            {/* Date + circle */}
                            {showDate && (
                                <>
                                    <div
                                        style={{
                                            position: "absolute",
                                            left: "-80px",
                                            top: "15px",
                                            fontWeight: 600,
                                            color: "#000",
                                            fontSize: "14px",
                                        }}
                                    >
                                        {entry.caseFactDate}
                                    </div>

                                    {/* Circle */}
                                    {!isLast && (
                                        <div
                                            style={{
                                                position: "absolute",
                                                left: "56px",
                                                top: "20px",
                                                width: "14px",
                                                height: "14px",
                                                backgroundColor: "#000",
                                                borderRadius: "50%",
                                                zIndex: 2,
                                            }}
                                        ></div>)}
                                </>
                            )}
                            {!isLast && (
                                <div
                                    style={{
                                        position: "absolute",
                                        left: "61px",
                                        top: "35px",
                                        height: "calc(100% + 60px)",
                                        width: "4px",
                                        backgroundColor: "#000",
                                        zIndex: 1,
                                    }}
                                ></div>
                            )}

                            {isLast && (
                                <>
                                    <div
                                        style={{
                                            position: "absolute",
                                            left: "56px",
                                            top: "30px",
                                            width: "14px",
                                            height: "14px",
                                            backgroundColor: "#000",
                                            borderRadius: "50%",
                                            zIndex: 2,
                                        }}
                                    ></div>
                                </>
                            )}

                            {/* Card */}
                            <div
                                style={{
                                    backgroundColor: color,
                                    padding: "20px",
                                    borderRadius: "8px",
                                    width: "75%",
                                    boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                                    marginLeft: "100px",
                                }}
                            >
                                <div style={{ fontWeight: "bold", fontSize: "15px" }}>
                                    {entry.caseFactLabel}
                                </div>

                                <div style={{ fontSize: "14px", color: "#333", marginTop: "8px", lineHeight: "1.5" }}>
                                    <strong>Provider:</strong> {entry?.caseFactProvider || 'N/A'}<br />
                                    <strong>Organization:</strong> {entry?.caseFactOrg || 'N/A'}<br />
                                    <strong>Page Range:</strong> {entry?.caseFactPageRange || 'N/A'}<br />
                                    <div style={{ display: "flex", alignItems: "flex-start" }}>
                                        <strong style={{ minWidth: "90px" }}>Summary:</strong>
                                        <span style={{ flex: 1, textAlign: "justify" }}>
                                            {entry?.caseFactsSummary || 'N/A'}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    };

    function randomPrefix() {
        return Math.floor(100 + Math.random() * 900); // 3-digit number between 100 and 999
    }

    const handleDownloadFastEnhancedbkpwithoutdetails = async () => {
        setIsDownloading(true);
        try {
            const id = localStorage.getItem("caseID");
            const now = new Date();
            const pdf = new jsPDF("p", "mm", "a4");
            const pad = (n) => String(n).padStart(2, "0");
            const pageWidth = 210;
            const pageHeight = 297;
            const margin = 12;
            const lineX = margin + 25; // x position of vertical timeline line
            let y = margin;

            const fileName = `File Name: ${caseName}`;
            const timelineLabel = "Vertical Timeline Report";

            const hexToRgb = (hex) => {
                const bigint = parseInt(hex.replace("#", ""), 16);
                const r = (bigint >> 16) & 255;
                const g = (bigint >> 8) & 255;
                const b = bigint & 255;
                return [r, g, b];
            };
            const logoDataUrl = await fetch(Logo)
                .then(res => res.blob())
                .then(blob => new Promise(resolve => {
                    const reader = new FileReader();
                    reader.onloadend = () => resolve(reader.result);
                    reader.readAsDataURL(blob);
                }));
            const logoWidth = 27;
            const logoHeight = 5;
            const drawLogo = () => {
                pdf.addImage(logoDataUrl, "PNG", pageWidth - logoWidth - margin, margin, logoWidth, logoHeight);
            };


            const drawDownArrow = (x, y, size = 2, shaftLength = 5) => {
                pdf.setDrawColor(0);
                pdf.setFillColor(0, 0, 0);

                // Draw the shaft
                pdf.setLineWidth(0.7);
                pdf.line(x, y, x, y + shaftLength);

                // Draw the triangle tip
                pdf.triangle(
                    x - size, y + shaftLength,
                    x + size, y + shaftLength,
                    x, y + shaftLength + size * 1.5,
                    "F"
                );
            };

            const padding = 4; // padding inside cards
            const lineHeight = 6; // line height for text
            let maxWidth = pageWidth - 40; // Adjust based on page margins
            let wrappedText = pdf.splitTextToSize(fileName, maxWidth);
            // --- Title Page ---
            pdf.setFont("helvetica", "bold");
            pdf.setFontSize(20);
            pdf.text(wrappedText, pageWidth / 2, pageHeight / 2 - 10, { align: "center" });

            pdf.setFont("helvetica", "normal");
            pdf.setFontSize(18);
            pdf.text(timelineLabel, pageWidth / 2, pageHeight / 2 + 10, { align: "center" });

            drawLogo();
            pdf.addPage();

            let lastDate = "";
            // Function to draw the vertical timeline line full height on current page
            const drawTimelineLine = () => {
                pdf.setDrawColor(0);
                pdf.setLineWidth(0.7);
                pdf.line(lineX, margin, lineX, pageHeight - margin);
            };

            // drawTimelineLine();

            let lastCircleY = null;
            const drawTimelineLineSegment = (fromY, toY) => {
                pdf.setDrawColor(0);
                pdf.setLineWidth(0.7);
                pdf.line(lineX, fromY, lineX, toY);
            };
            for (let i = 0; i < timelineData.length; i++) {
                const entry = timelineData[i];
                const cardWidth = pageWidth - margin - (lineX + 10);
                let maxTextWidth = cardWidth - 2 * padding;

                if (i === 0) {
                    maxTextWidth += 100
                }

                // Split text into lines
                const cardTitleLines = pdf.splitTextToSize(entry.caseFactLabel, maxTextWidth);
                const cardSummaryLines = pdf.splitTextToSize(entry.caseFactsSummary, maxTextWidth);

                // Calculate card height dynamically
                const cardHeight = padding * 2 + (cardTitleLines.length * (lineHeight + 1)) + (cardSummaryLines.length * lineHeight);

                // Add new page if card won't fit
                if (y + cardHeight + margin > pageHeight) {
                    if (lastCircleY !== null) drawTimelineLineSegment(lastCircleY, pageHeight - margin);


                    pdf.addPage();
                    y = margin;
                    // drawTimelineLine();

                    if (lastCircleY !== null) drawTimelineLineSegment(margin, y + cardHeight / 2);

                    lastCircleY = null;
                }

                // Circle center
                const circleY = y + 10;
                if (i === 0) {
                    drawDownArrow(lineX, circleY - 12); // 8mm above the first circle
                }

                // Draw connecting line
                if (lastCircleY !== null) drawTimelineLineSegment(lastCircleY, circleY);

                // Draw circle and date
                if (entry.caseFactDate !== lastDate) {
                    pdf.setFillColor(0, 0, 0);
                    pdf.circle(lineX, circleY, 2, "F");
                    pdf.setFontSize(10);
                    pdf.text(entry.caseFactDate, lineX - 10, circleY + 3, { align: "right" });
                    lastDate = entry.caseFactDate;
                }
                if (i === timelineData.length - 1) {
                    pdf.setFillColor(0, 0, 0); // Set the fill color for the circle (black)
                    pdf.circle(lineX, circleY, 2, "F"); // Draw the circle for the last entry
                }

                // Draw card background
                const cardX = lineX + 10;
                const color = bgColors[i % bgColors.length];
                const [r, g, b] = hexToRgb(color);
                pdf.setFillColor(r, g, b);
                pdf.roundedRect(cardX, y, cardWidth, cardHeight, 2, 2, "F");

                // Draw text inside card
                let textY = y + padding + lineHeight; // start below top padding

                if (i === 0) {
                    textY = y + padding + lineHeight; // Correct any misalignment
                }



                cardTitleLines.forEach((line) => {
                    pdf.setFont("helvetica", "bold");
                    pdf.setFontSize(10);
                    pdf.text(line, cardX + padding, textY);
                    textY += lineHeight + 1; // extra spacing between title lines
                });

                cardSummaryLines.forEach((line) => {
                    pdf.setFont("helvetica", "normal");
                    pdf.setFontSize(10);
                    pdf.text(line, cardX + padding, textY);
                    textY += lineHeight;
                });

                lastCircleY = circleY;
                y += cardHeight + 10; // spacing between cards
            }

            if (lastCircleY !== null) drawTimelineLineSegment(lastCircleY, lastCircleY);

            // Add page numbers
            const totalPages = pdf.getNumberOfPages();
            for (let i = 2; i <= totalPages; i++) {
                pdf.setPage(i);
                pdf.setFontSize(10);
                pdf.text(`AttestaAI | Page ${i - 1} of ${totalPages - 1} `, pageWidth - margin, pageHeight - 10, { align: "right" });
            }

            // pdf.save("timeline.pdf");
            const pdfBlob = pdf.output("blob");
            const url = URL.createObjectURL(pdfBlob);
            // const printWindow = window.open(url);
            // printWindow.onload = () => printWindow.print();

            const zip = new JSZip();
            zip.file(`${randomPrefix()}${id}${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}.pdf`, pdfBlob, { compression: "DEFLATE", compressionOptions: { level: 9 } });

            zip.generateAsync({ type: "blob", compression: "DEFLATE" }).then((zipBlob) => {
                saveAs(zipBlob, `${randomPrefix()}${id}${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}.zip`);
            });
        } catch (error) {
            console.error("Error generating PDF:", error);
        } finally {
            setIsDownloading(false);
        }
    };
    const handleDownloadFastEnhanced11 = async () => {
        setIsDownloading(true);
        try {
            const id = localStorage.getItem("caseID");
            const now = new Date();
            const pdf = new jsPDF("p", "mm", "a4");

            const pad = (n) => String(n).padStart(2, "0");
            const pageWidth = 210;
            const pageHeight = 297;
            const margin = 12;
            const lineX = margin + 25;
            let y = margin;

            const fileName = `File Name: ${caseName}`;
            const timelineLabel = "Vertical Timeline Report";

            const hexToRgb = (hex) => {
                const bigint = parseInt(hex.replace("#", ""), 16);
                const r = (bigint >> 16) & 255;
                const g = (bigint >> 8) & 255;
                const b = bigint & 255;
                return [r, g, b];
            };

            // Load logo
            const logoDataUrl = await fetch(Logo)
                .then(res => res.blob())
                .then(blob => new Promise(resolve => {
                    const reader = new FileReader();
                    reader.onloadend = () => resolve(reader.result);
                    reader.readAsDataURL(blob);
                }));

            const logoWidth = 27;
            const logoHeight = 5;
            const drawLogo = () => {
                pdf.addImage(logoDataUrl, "PNG", pageWidth - logoWidth - margin, margin, logoWidth, logoHeight);
            };

            // Draw down arrow at top
            const drawDownArrow = (x, y, size = 2, shaftLength = 5) => {
                pdf.setDrawColor(0);
                pdf.setFillColor(0, 0, 0);
                pdf.setLineWidth(0.7);
                pdf.line(x, y, x, y + shaftLength);
                pdf.triangle(
                    x - size, y + shaftLength,
                    x + size, y + shaftLength,
                    x, y + shaftLength + size * 1.5,
                    "F"
                );
            };

            // --- Title Page ---
            pdf.setFont("helvetica", "bold");
            pdf.setFontSize(20);
            pdf.text(fileName, pageWidth / 2, pageHeight / 2 - 10, { align: "center" });

            pdf.setFont("helvetica", "normal");
            pdf.setFontSize(18);
            pdf.text(timelineLabel, pageWidth / 2, pageHeight / 2 + 10, { align: "center" });

            drawLogo();
            pdf.addPage();

            let lastDate = "";
            let lastCircleY = null;
            const lineHeight = 6;
            const padding = 4;

            const drawTimelineLineSegment = (fromY, toY) => {
                pdf.setDrawColor(0);
                pdf.setLineWidth(0.7);
                pdf.line(lineX, fromY, lineX, toY);
            };

            for (let i = 0; i < timelineData.length; i++) {
                const entry = timelineData[i];
                const cardWidth = pageWidth - margin - (lineX + 10);
                const cardX = lineX + 10;
                const [r, g, b] = hexToRgb(bgColors[i % bgColors.length]);
                let maxTextWidth = cardWidth - 2 * padding;
                if (i === 0) {
                    maxTextWidth += 100
                }
                // Wrap summary text
                const titleLines = pdf.splitTextToSize(entry.caseFactLabel, maxTextWidth); // Wrap title

                const summaryLines = pdf.splitTextToSize(entry.caseFactsSummary, maxTextWidth - 20);
                const estimatedHeight = 30 + (titleLines.length * lineHeight) + (summaryLines.length * lineHeight - 10);

                // Add new page if overflow
                if (y + estimatedHeight + margin > pageHeight) {
                    if (lastCircleY !== null) drawTimelineLineSegment(lastCircleY, pageHeight - margin);
                    pdf.addPage();
                    y = margin;
                    lastCircleY = null;
                }

                // Circle and date
                const circleY = y + 10;
                if (i === 0) drawDownArrow(lineX, circleY - 12);
                if (lastCircleY !== null) drawTimelineLineSegment(lastCircleY, circleY);

                pdf.setFillColor(0, 0, 0);
                pdf.circle(lineX, circleY, 2, "F");

                if (entry.caseFactDate !== lastDate) {
                    pdf.setFontSize(10);
                    pdf.text(entry.caseFactDate, lineX - 10, circleY + 3, { align: "right" });
                    lastDate = entry.caseFactDate;
                }

                // Draw card background
                pdf.setFillColor(r, g, b);
                pdf.roundedRect(cardX, y, cardWidth, estimatedHeight, 2, 2, "F");

                // Draw text content inside card
                let textY = y + padding + lineHeight;
                pdf.setFontSize(10);

                // --- Title ---
                // pdf.setFont("helvetica", "bold");
                // pdf.text(entry.caseFactLabel, cardX + padding, textY);
                // textY += lineHeight + 1;
                pdf.setFont("helvetica", "bold");
                pdf.text(titleLines, cardX + padding, textY); // Draw wrapped title
                textY += titleLines.length * lineHeight + 2;  // Adjust height for wr

                // --- Date ---
                // pdf.setFont("helvetica", "bold");
                // pdf.text("Date:", cardX + padding, textY);
                // pdf.setFont("helvetica", "normal");
                // pdf.text(entry.caseFactDate, cardX + padding + 9, textY);
                // textY += lineHeight;

                // --- Provider ---
                pdf.setFont("helvetica", "bold");
                pdf.text("Provider:", cardX + padding, textY);
                pdf.setFont("helvetica", "normal");
                pdf.text(entry.caseFactProvider, cardX + padding + 16, textY);
                textY += lineHeight;

                // --- Organization ---
                pdf.setFont("helvetica", "bold");
                pdf.text("Organization:", cardX + padding, textY);
                pdf.setFont("helvetica", "normal");
                pdf.text(entry.caseFactOrg, cardX + padding + 24, textY);
                textY += lineHeight;

                // --- Page Range ---
                pdf.setFont("helvetica", "bold");
                pdf.text("Page Range:", cardX + padding, textY);
                pdf.setFont("helvetica", "normal");
                pdf.text(entry.caseFactPageRange, cardX + padding + 22, textY);
                textY += lineHeight + 1;

                // --- ✅ Summary (starts on same line as label)
                pdf.setFont("helvetica", "bold");
                pdf.text("Summary:", cardX + padding, textY);

                pdf.setFont("helvetica", "normal");
                const summaryX = cardX + padding + 19;
                pdf.text(summaryLines, summaryX, textY);

                // Update for next iteration
                lastCircleY = circleY;
                y += estimatedHeight + 10;
            }

            if (lastCircleY !== null) drawTimelineLineSegment(lastCircleY, lastCircleY);

            // Footer: page numbers
            const totalPages = pdf.getNumberOfPages();
            for (let i = 2; i <= totalPages; i++) {
                pdf.setPage(i);
                pdf.setFontSize(10);
                pdf.text(
                    `AttestaAI | Page ${i - 1} of ${totalPages - 1}`,
                    pageWidth - margin,
                    pageHeight - 10,
                    { align: "right" }
                );
            }

            // Open generated PDF in new tab
            const pdfBlob = pdf.output("blob");
            const url = URL.createObjectURL(pdfBlob);
            // const printWindow = window.open(url);
            // printWindow.onload = () => printWindow.print();

            const zip = new JSZip();
            zip.file(`${randomPrefix()}${id}${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}.pdf`, pdfBlob, { compression: "DEFLATE", compressionOptions: { level: 9 } });

            zip.generateAsync({ type: "blob", compression: "DEFLATE" }).then((zipBlob) => {
                saveAs(zipBlob, `${randomPrefix()}${id}${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}.zip`);
            });

        } catch (error) {
            console.error("Error generating PDF:", error);
        } finally {
            setIsDownloading(false);
        }
    };


    const handleDownloadFastEnhanced = async () => {
        setIsDownloading(true);
        try {
            const id = localStorage.getItem("caseID");
            const now = new Date();
            const pdf = new jsPDF("p", "mm", "a4");

            const pad = (n) => String(n).padStart(2, "0");
            const pageWidth = 210;
            const pageHeight = 297;
            const margin = 12;
            const lineX = margin + 25;
            let y = margin;

            const fileName = `File Name: ${caseName}`;
            const timelineLabel = "Vertical Timeline Report";

            const hexToRgb = (hex) => {
                const bigint = parseInt(hex.replace("#", ""), 16);
                const r = (bigint >> 16) & 255;
                const g = (bigint >> 8) & 255;
                const b = bigint & 255;
                return [r, g, b];
            };

            // Load logo
            const logoDataUrl = await fetch(Logo)
                .then(res => res.blob())
                .then(blob => new Promise(resolve => {
                    const reader = new FileReader();
                    reader.onloadend = () => resolve(reader.result);
                    reader.readAsDataURL(blob);
                }));

            const logoWidth = 27;
            const logoHeight = 5;
            const drawLogo = () => {
                pdf.addImage(logoDataUrl, "PNG", pageWidth - logoWidth - margin, margin, logoWidth, logoHeight);
            };

            // Draw down arrow at top
            const drawDownArrow = (x, y, size = 2, shaftLength = 5) => {
                pdf.setDrawColor(0);
                pdf.setFillColor(0, 0, 0);
                pdf.setLineWidth(0.7);
                pdf.line(x, y, x, y + shaftLength);
                pdf.triangle(
                    x - size, y + shaftLength,
                    x + size, y + shaftLength,
                    x, y + shaftLength + size * 1.5,
                    "F"
                );
            };

            // --- Title Page ---
            // pdf.setFont("helvetica", "bold");
            // pdf.setFontSize(20);
            // pdf.text(fileName, pageWidth / 2, pageHeight / 2 - 10, { align: "center" });

            let maxWidthlabel = pageWidth - 40; // Adjust based on page margins
            let wrappedText = pdf.splitTextToSize(fileName, maxWidthlabel);
            // --- Title Page ---
            pdf.setFont("helvetica", "bold");
            pdf.setFontSize(20);
            pdf.text(wrappedText, pageWidth / 2, pageHeight / 2 - 10, { align: "center" });

            pdf.setFont("helvetica", "normal");
            pdf.setFontSize(18);
            pdf.text(timelineLabel, pageWidth / 2, pageHeight / 2 + 10, { align: "center" });

            drawLogo();
            pdf.addPage();

            let lastDate = "";
            let lastCircleY = null;
            const lineHeight = 6;
            const padding = 4;

            const drawTimelineLineSegment = (fromY, toY) => {
                pdf.setDrawColor(0);
                pdf.setLineWidth(0.7);
                pdf.line(lineX, fromY, lineX, toY);
            };

            // Helper to justify text lines
            function drawJustifiedText(text, x, y, maxWidth, lineHeight) {
                const words = text.split(/\s+/);
                let line = "";
                let lines = [];
                const spaceWidth = pdf.getTextWidth(" ");

                // Break into lines
                for (let word of words) {
                    const testLine = line + word + " ";
                    const testWidth = pdf.getTextWidth(testLine);
                    if (testWidth > maxWidth && line !== "") {
                        lines.push(line.trim());
                        line = word + " ";
                    } else {
                        line = testLine;
                    }
                }
                lines.push(line.trim());

                // Draw each line
                lines.forEach((ln, i) => {
                    if (i === lines.length - 1) {
                        // Last line: normal left align
                        pdf.text(ln, x, y + i * lineHeight);
                    } else {
                        const wordsInLine = ln.split(/\s+/);
                        const lineWidth = pdf.getTextWidth(ln.replace(/\s+/g, " "));
                        const extraSpace = maxWidth - lineWidth;
                        const spacing = wordsInLine.length > 1
                            ? extraSpace / (wordsInLine.length - 1)
                            : 0;
                        let cursorX = x;
                        for (let j = 0; j < wordsInLine.length; j++) {
                            const w = wordsInLine[j];
                            pdf.text(w, cursorX, y + i * lineHeight);
                            cursorX += pdf.getTextWidth(w) + spaceWidth + spacing;
                        }
                    }
                });
                return lines.length * lineHeight;
            }

            for (let i = 0; i < timelineData.length; i++) {
                const entry = timelineData[i];
                const cardWidth = pageWidth - margin - (lineX + 10);
                const cardX = lineX + 10;
                const [r, g, b] = hexToRgb(bgColors[i % bgColors.length]);
                let maxTextWidth = cardWidth - 2 * padding;

                let titleLines = null;
                // Wrap title text
                if (i === 0) {
                    titleLines = pdf.splitTextToSize(entry.caseFactLabel, maxTextWidth + 70);
                } else {
                    titleLines = pdf.splitTextToSize(entry.caseFactLabel, maxTextWidth);

                }


                // Estimate height for summary with simple line wrap (to reserve space)
                const summaryLinesWrapped = pdf.splitTextToSize(entry.caseFactsSummary, maxTextWidth - 20);
                let estimatedHeight = 35 + (titleLines.length * lineHeight) + (summaryLinesWrapped.length * lineHeight);

                // if (i === 0) {
                //     estimatedHeight -= 25;
                // }
                // Add new page if overflow
                if (y + estimatedHeight + margin > pageHeight) {
                    if (lastCircleY !== null) drawTimelineLineSegment(lastCircleY, pageHeight - margin);
                    pdf.addPage();
                    y = margin;
                    if (lastCircleY !== null) {
                        // The Y position of the first circle on the new page will be y + 10 (your circle offset)
                        const firstCircleYNewPage = y + 10;
                        drawTimelineLineSegment(margin, firstCircleYNewPage);
                    }

                    lastCircleY = null;
                }

                // Circle and date
                const circleY = y + 10;
                if (i === 0) drawDownArrow(lineX, circleY - 12);
                if (lastCircleY !== null) drawTimelineLineSegment(lastCircleY, circleY);

                pdf.setFillColor(0, 0, 0);
                pdf.circle(lineX, circleY, 2, "F");

                if (entry.caseFactDate !== lastDate) {
                    pdf.setFontSize(10);
                    pdf.text(entry.caseFactDate, lineX - 10, circleY + 3, { align: "right" });
                    lastDate = entry.caseFactDate;
                }

                // Draw card background
                pdf.setFillColor(r, g, b);
                pdf.roundedRect(cardX, y, cardWidth, estimatedHeight, 2, 2, "F");

                // Draw text content inside card
                let textY = y + padding + lineHeight;
                pdf.setFontSize(10);

                // Title
                pdf.setFont("helvetica", "bold");
                pdf.text(titleLines, cardX + padding, textY);
                textY += titleLines.length * lineHeight + 2;

                // Provider
                pdf.setFont("helvetica", "bold");
                pdf.text("Provider:", cardX + padding, textY);
                pdf.setFont("helvetica", "normal");
                pdf.text(entry.caseFactProvider, cardX + padding + 16, textY);
                textY += lineHeight;

                // Organization
                pdf.setFont("helvetica", "bold");
                pdf.text("Organization:", cardX + padding, textY);
                pdf.setFont("helvetica", "normal");
                pdf.text(entry.caseFactOrg, cardX + padding + 24, textY);
                textY += lineHeight;

                // Page Range
                pdf.setFont("helvetica", "bold");
                pdf.text("Page Range:", cardX + padding, textY);
                pdf.setFont("helvetica", "normal");
                pdf.text(entry.caseFactPageRange, cardX + padding + 22, textY);
                textY += lineHeight + 1;

                // Summary label
                pdf.setFont("helvetica", "bold");
                pdf.text("Summary:", cardX + padding, textY);

                // Draw justified summary text (starting on same line as label)
                pdf.setFont("helvetica", "normal");
                const summaryX = cardX + padding + 19;
                const usedHeight = drawJustifiedText(entry.caseFactsSummary, summaryX, textY, maxTextWidth - 20, lineHeight);
                textY += usedHeight;

                // Update for next iteration
                lastCircleY = circleY;
                y += estimatedHeight + 10;
            }

            if (lastCircleY !== null) drawTimelineLineSegment(lastCircleY, lastCircleY);

            // Footer: page numbers
            const totalPages = pdf.getNumberOfPages();
            for (let i = 2; i <= totalPages; i++) {
                pdf.setPage(i);
                pdf.setFontSize(10);
                pdf.text(
                    `AttestaAI | Page ${i - 1} of ${totalPages - 1}`,
                    pageWidth - margin,
                    pageHeight - 10,
                    { align: "right" }
                );
            }

            // Open generated PDF in new tab
            const pdfBlob = pdf.output("blob");
            const url = URL.createObjectURL(pdfBlob);

            const zip = new JSZip();
            zip.file(`${randomPrefix()}${id}${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}.pdf`, pdfBlob, { compression: "DEFLATE", compressionOptions: { level: 9 } });

            zip.generateAsync({ type: "blob", compression: "DEFLATE" }).then((zipBlob) => {
                saveAs(zipBlob, `${randomPrefix()}${id}${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}.zip`);
            });

        } catch (error) {
            console.error("Error generating PDF:", error);
        } finally {
            setIsDownloading(false);
        }
    };

    return (
        <Modal
            show={isverticaltimeopen}
            onHide={handleCloseSverticaltimelineModal}
            size="xl"
            centered
            backdrop="static"
        >
            <Modal.Body
                style={{
                    maxHeight: "calc(100vh - 160px)",
                    overflowY: "auto",
                    padding: "20px 40px",
                }}
            >
                <div className="text-center mb-3">
                    <span style={{ fontSize: "20px", fontWeight: 600, color: "#333" }}>
                        Vertical Timeline Preview
                    </span>
                </div>

                {verticalloading ? (
                    <div className="text-center py-5">Loading...</div>
                ) : timelineData.length > 0 ? (
                    <div ref={ref}>{renderTimelineCards()}</div>
                ) : (
                    <div className="text-center py-5">No report avaiable...</div>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseSverticaltimelineModal}>
                    Close
                </Button>
                <Button variant="primary" onClick={handleDownloadFastEnhanced} disabled={isDownloading}>
                    {isDownloading ? (
                        <>
                            {/* <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span> */}
                            Downloading...
                        </>
                    ) : (
                        "Download"
                    )}
                </Button>

            </Modal.Footer>
        </Modal>
    );
};

export default VerticalTimelinePreview;
